import { createFileRoute, retainSearchParams } from "@tanstack/react-router";
import { z } from "zod";

import { coerceToStringArray } from "@/core/lib/search-params";
import LoadingScreen from "@/core/ui/layout/LoadingScreen";
import { getWorkflowActionsOptions } from "@/openapi/@tanstack/react-query.gen";

export const Route = createFileRoute("/_protected/workflows_/run/")({
  validateSearch: z.object({
    project_id: z.uuid().optional(),
    // absent when viewing a stored run: the execution is the identity, and
    // its workflow may not exist any more
    workflow_id: z.uuid().optional(), // audit task id
    action_id: z
      .preprocess(coerceToStringArray, z.array(z.uuid()).min(1))
      .optional(), // available action ids
    e: z.uuid().optional(), // execution id
    // action id while running, checkpoint thread id when viewing a stored run
    a: z.string().optional(),
    p: z.string().optional(), // parameters_overrides_json (JSON-encoded)
    promotion_request_id: z.uuid().optional(), // pending proposal under review
    // explicit run intent: set only by start-workflow flows. absent means
    // view-only: stored results are fetched and nothing is ever executed
    run: z.boolean().optional(),
  }),
  search: {
    middlewares: [retainSearchParams(true)],
  },
  pendingComponent: () => <LoadingScreen isActive noDim />,
  loaderDeps: ({ search: { action_id, project_id, workflow_id, e, p } }) => ({
    action_id,
    project_id,
    workflow_id,
    e,
    p,
  }),
  loader: ({ context: { queryClient, ...context }, deps }) => {
    const orgId = context.user.organization?.id;

    if (!orgId) {
      throw new Error("Organization not found");
    }

    if (!deps.workflow_id) return;

    void queryClient.query({
      ...getWorkflowActionsOptions({
        path: {
          org_id: orgId,
          workflow_id: deps.workflow_id,
        },
      }),
      staleTime: "static",
    });
  },
});
